import template from './sw-cms-block-image.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
